import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChevronDown = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 8,
	height: 6,
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M.5 1.778 1.594.667 4 3.11 6.406.667 7.5 1.777 4 5.334.5 1.778Z"
	})]
});
const ForwardRef = forwardRef(SvgChevronDown);
export { ForwardRef as ReactComponent };
